<div class="directCallComment panel" [class.stickyMode]="stickyMode" [class.withMenu]="withMenu">
  @if (!stickyMode) {
    <div class="close" (click)="closeChat()">
      <label class="close-icon">
        <i class="material-icons notranslate">close</i>
      </label>
    </div>
  }

  <div class="comments">
    @if (!stickyMode) {
      <h3 class="comments-title">{{'COMMENTS.TOOL_TIP' | translate}}</h3>
    }

    <div class="comment">
      <div class="visible-info title">
        <div class="name bold">
          <p>{{ 'COMMENTS.ADD_NEW' | translate }}</p>
          <div class="row-icon add-icon" (click)="createComment(!stickyMode)"></div>
        </div>
      </div>
    </div>

  </div>


  @if (userDataService.assetInfo) {
    <div class="allcomments">
      @for (entry of userDataService.assetInfo.comments; track entry) {
        <div class="comment">
          <div class="visible-info-rows">
            <div class="visible-info-row">
              <div class="smallText">
                <p>{{entry.userName}}</p>
              </div>
              @if (entry.date) {
                <div class="smallText">
                  <p>{{entry.date | date:'medium' }}</p>
                </div>
              }
            </div>
            <div class="visible-info-row">
              @if (entry.comment) {
                <div class="name">
                  <p>{{entry.comment}}</p>
                </div>
              }
              <div class="delete" matTooltip="{{ 'COMMENTS.DELETE' | translate }}">
                <img src="/assets/images/buttons/trash.svg" (click)="delete(entry.id)" />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
